import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, Text} from '@optimaxdev/design-system';
import {GooglePayD, Icon} from '@optimaxdev/icons';
import {PaymentMethodType} from '@primer-io/checkout-web';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {useGetErrorAndSendAnalytics} from 'desktop/pages/checkout/hooks/primer/useGetErrorAndSendAnalytics/useGetErrorAndSendAnalytics';
import {usePrimerNativeButton} from 'desktop/pages/checkout/hooks/primer/usePrimerNativeButton';

import {primerGooglePayOptions} from '../../../paymentGooglePayPrimer/constants';
import {PaymentFooterWrapper} from '../../common/paymentFooter/paymentFooterWrapper';

import {PaymentWrapper} from '../../common/paymentWrapper/paymentWrapper';

import s from './paymentGooglePayPrimerOneStep.scss';

/**
 * Google Pay with primer UI component
 */
export const PaymentGooglePayPrimerOneStep = () => {
    const {isAvailable, isReady} = usePrimerNativeButton({
        buttonId: primerGooglePayOptions.id,
        externalMethodType: PaymentMethodType.GOOGLE_PAY,
        internalMethodType: PAYMENTS.METHOD_PRIMER_GOOGLE_PAY,
        onClick: () => {
            sendDesktopAnalyticsEvent(
                CHECKOUT_PAYMENT_STEP,
                {
                    message: 'CTA - Google Pay Primer',
                    method: 'Payment',
                },
                true,
            );
        },
    });

    const {error} = useGetErrorAndSendAnalytics(PAYMENTS.METHOD_PRIMER_GOOGLE_PAY);

    return (
        <>
            <PaymentWrapper errorMessage={error} showSkeleton={!isReady}>
                <Icon height="24px" icon={GooglePayD} />
                <Text color={Colors.limedSpruce} lineHeight="22px" padding="0 0 0 10px" size="14px">
                    Google Pay
                </Text>
            </PaymentWrapper>

            <PaymentFooterWrapper isLoading={!isAvailable} label="Google Pay">
                <div className={s.googlePay} id={primerGooglePayOptions.id} />
            </PaymentFooterWrapper>
        </>
    );
};
